<script setup lang="ts">
import type { BaseAccordionItem } from '~/components/Base/BaseAccordion.vue';

export interface StoryblokAccordionProps {
    blok: StoryblokAccordion;
}

// PROPS
const { blok } = defineProps<StoryblokAccordionProps>();

// DATA
const accordionItems = computed<BaseAccordionItem[]>(() =>
    (blok.items ?? []).map(item => ({
        label: item.label ?? '',
        defaultOpen: item.defaultOpen,
    }))
);
</script>

<template>
    <BaseAccordion v-editable="blok" :items="accordionItems" :size="blok.size" :type="blok.type" :default-open="blok.defaultOpen">
        <template #body="{ index }">
            <StoryblokRichTextOverride v-if="!!blok.items?.[index]?.content" :doc="blok.items[index].content" class="max-w-none" />
        </template>
    </BaseAccordion>
</template>
